import { Box } from '@material-ui/core'

import { PagesProps } from '../../../../@types'
import { MainTitle } from '../../../../components'

// ========= Incons =========

// const useStyles = makeStyles((theme: Theme) =>
//   createStyles({
//     root: {
//       fleGrow: 1
//     }
//   }),
// )

export const Notifications = ({ page }: PagesProps) => {
	// const classes = useStyles()
	return (
		<Box>
			<MainTitle
				breadcrumbs={[page]}
				title={page.name}
				description="Stay up to date on Assignments, new content, student updates and more!"
			/>
		</Box>
	)
}
